import { BaseService } from 'src/app/shared/services/base-service.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CurrentUserDto } from '../../models/current-user.model';
import { CryptoService } from '../crypto';
import { LoginforignerDto } from '../../models/loginforigner.model';
import { VerifyDto } from '../../models/verify.model';
import { ChangepasswordDto } from '../../models/changepassword.model';
@Injectable({ providedIn: 'root' })
export class AuthForignerService extends BaseService {
  
  constructor(private http: HttpClient,
    private cryptoService: CryptoService
  ) {
    super();
  }
  
  currentUserInfo: CurrentUserDto = {};

  Register(email: any): Observable<any> {
    return this.http.post<any>('/api/authforigner/register?email='+ email,null);
  }
  Registerusingpaswword(email: any,password:any): Observable<any> {
    return this.http.post<any>('/api/authforigner/registerwithpassword?email='+ email+'&password='+password,null);
  }
  Login(login: LoginforignerDto): Observable<any> {
    return this.http.post<any>('/api/Auth/login',login);
  }
  Verify(verify: VerifyDto): Observable<any> {
    return this.http.post<any>('/api/authforigner/verify',verify);
  }
  ChangePassword(change: ChangepasswordDto): Observable<any> {
    return this.http.post<any>('/api/Users/changepassword',change);
  }

}
